import type {FC} from 'react';

import type {WithTestID} from '../../../../utils/utility-types';

import {Clickable} from '../../../../uikit/Clickable';
import * as S from './styles';

interface Props extends WithTestID {
  onClick: () => Promise<void>;
}

export const SupportChatButtonJSX: FC<Props> = ({onClick, testID}) => {
  return (
    <S.Container>
      <Clickable onClick={onClick} testID={testID}>
        <S.IconContainer>
          <S.Icon />
        </S.IconContainer>
      </Clickable>
    </S.Container>
  );
};
